import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'
import moment from 'moment'

// -----------------------------------------------------------------------------
// API Calls

function fetchGroupTracker (groupName) {
  return utils.makeApiCall({
    url: `/api/groups/${groupName}`,
    actionRequest: ActionTypes.REQUEST_TRACKER,
    actionReceive: ActionTypes.RECEIVE_TRACKER,
    actionFailure: ActionTypes.REQUEST_TRACKER_FAILURE,
    authenticated: true,
    actionProps: {
      groupName: groupName
    }
  })
}

function fetchTrackerPlan (trackerId) {
  return utils.makeApiCall({
    url: `/api/v3/launch-tracker/${trackerId}/primary-benchmark/metrics`,
    method: 'GET',
    actionRequest: ActionTypes.REQUEST_TRACKER_PLAN,
    actionReceive: ActionTypes.RECEIVE_TRACKER_PLAN,
    actionFailure: ActionTypes.REQUEST_TRACKER_PLAN_FAILURE,
    authenticated: true,
    actionProps: {
      trackerId: trackerId
    }
  })
}

function fetchTrackerTimelineView (trackerId) {
  return utils.makeApiCall({
    url: `/api/v3/launch-tracker/${trackerId}/primary-benchmark/timeline/metrics`,
    method: 'GET',
    actionRequest: ActionTypes.REQUEST_TRACKER_TIMELINE_VIEW,
    actionReceive: ActionTypes.RECEIVE_TRACKER_TIMELINE_VIEW,
    actionFailure: ActionTypes.REQUEST_TRACKER_TIMELINE_VIEW_FAILURE,
    authenticated: true,
    actionProps: {
      trackerId: trackerId
    }
  })
}

function fetchSingleTrackerEntityPlan (trackerId, trackerEntityId) {
  return utils.makeApiCall({
    url: `/api/v3/launch-tracker/${trackerId}/metrics/entities/${trackerEntityId}`,
    method: 'GET',
    actionRequest: ActionTypes.REQUEST_SINGLE_TRACKER_PLAN,
    actionReceive: ActionTypes.RECEIVE_SINGLE_TRACKER_PLAN,
    actionFailure: ActionTypes.REQUEST_SINGLE_TRACKER_PLAN_FAILURE,
    authenticated: true,
    actionProps: {
      trackerId: trackerId,
      entityId: trackerEntityId
    }
  })
}

function fetchSingleTrackerEntityTimeLineView (trackerId, trackerEntityId) {
  return utils.makeApiCall({
    url: `/api/v3/launch-tracker/${trackerId}/timeline/metrics/entities/${trackerEntityId}`,
    method: 'GET',
    actionRequest: ActionTypes.REQUEST_SINGLE_TRACKER_TIMELINE_VIEW,
    actionReceive: ActionTypes.RECEIVE_SINGLE_TRACKER_TIMELINE_VIEW,
    actionFailure: ActionTypes.REQUEST_TRACKER_TIMELINE_VIEW_FAILURE,
    authenticated: true,
    actionProps: {
      trackerId: trackerId,
      entityId: trackerEntityId
    }
  })
}

function fetchAverageBenchMarkTrackerPlan (trackerId) {
  return utils.makeApiCall({
    url: `/api/v3/launch-tracker/${trackerId}/average-benchmark/metrics`,
    method: 'GET',
    actionRequest: ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN,
    actionReceive: ActionTypes.RECEIVE_AVERAGE_BENCH_MARK_TRACKER_PLAN,
    actionFailure: ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_PLAN_FAILURE,
    authenticated: true,
    actionProps: {
      trackerId: trackerId
    }
  })
}

function fetchAverageBenchMarkTrackerTimelineView (trackerId) {
  return utils.makeApiCall({
    url: `/api/v3/launch-tracker/${trackerId}/average-benchmark/timeline/metrics`,
    method: 'GET',
    actionRequest: ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW,
    actionReceive: ActionTypes.RECEIVE_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW,
    actionFailure: ActionTypes.REQUEST_AVERAGE_BENCH_MARK_TRACKER_TIMELINE_VIEW_FAILURE,
    authenticated: true,
    actionProps: {
      trackerId: trackerId
    }
  })
}
function fetchTrackerPrimaryEntityDetails (trackerId, topicId) {
  return utils.makeApiCall({
    url: `/api/launch-tracker/${trackerId}/details`,
    actionRequest: ActionTypes.REQUEST_TRACKER_PRIMARY_ENTITY_DETAILS,
    actionReceive: ActionTypes.RECEIVE_TRACKER_PRIMARY_ENTITY_DETAILS,
    actionFailure: ActionTypes.REQUEST_TRACKER_PRIMARY_ENTITY_FAILURE,
    authenticated: true,
    actionProps: {
      trackerId: trackerId,
      topicId: topicId
    }
  })
}

function fetchTrackerTeasersAndTrailers (trackerId, trackerEntityId) {
  return utils.makeApiCall({
    url: `/api/launch-tracker/${trackerId}/teasers-trailers/${trackerEntityId}`,
    method: 'GET',
    actionRequest: ActionTypes.REQUEST_TRACKER_TEASERS_TRAILERS,
    actionReceive: ActionTypes.RECEIVE_TRACKER_TEASERS_TRAILERS,
    actionFailure: ActionTypes.REQUEST_TRACKER_TEASERS_TRAILERS_FAILURE,
    authenticated: true,
    actionProps: {
      trackerId,
      trackerEntityId
    }
  })
}

function fetchTrackerWhatsNew (trackerId, trackerEntityId, launchDate) {
  const startDate = moment(launchDate).subtract(1, 'months').format('YYYY-MM-DD')
  const endDate = moment(launchDate).subtract(-2, 'months').format('YYYY-MM-DD')
  const body = {
    start_date: startDate,
    end_date: endDate
  }
  return utils.makeApiCall({
    url: '/api/insights/calendar',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TRACKER_WHATS_NEW,
    actionReceive: ActionTypes.RECEIVE_TRACKER_WHATS_NEW,
    actionFailure: ActionTypes.REQUEST_TRACKER_WHATS_NEW_FAILURE,
    authenticated: true,
    actionProps: {
      trackerId,
      trackerEntityId,
      launchDate
    }
  })
}

function fetchTrackerWordCloud (trackerId, entityId) {
  return utils.makeApiCall({
    url: `/api/launch-tracker/${trackerId}/word-cloud/${entityId}`,
    actionRequest: ActionTypes.REQUEST_TRACKER_WORD_CLOUD,
    actionReceive: ActionTypes.RECEIVE_TRACKER_WORD_CLOUD,
    actionFailure: ActionTypes.REQUEST_TRACKER_WORD_CLOUD_FAILURE,
    authenticated: true,
    actionProps: {
      trackerId: trackerId,
      entityId: entityId
    }
  })
}

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchGroupTrackerIfNeeded (groupName) {
  return (dispatch, getState) => {
    const state = (getState().tracker.list || {})
    if (utils.shouldFetch(state)) {
      return dispatch(fetchGroupTracker(groupName))
    }
    return Promise.resolve()
  }
}

export function fetchTrackerPlanIfNeeded (trackerId) {
  return (dispatch, getState) => {
    const state = (getState().tracker.byId[trackerId] || {}).planDetails
    if (utils.shouldFetch(state)) {
      return dispatch(fetchTrackerPlan(trackerId))
    }
    return Promise.resolve()
  }
}

export function fetchTrackerTimelineViewIfNeeded (trackerId) {
  return (dispatch, getState) => {
    const state = (getState().tracker.byId[trackerId] || {}).timelineView
    if (utils.shouldFetch(state)) {
      return dispatch(fetchTrackerTimelineView(trackerId))
    }
    return Promise.resolve()
  }
}

export function fetchTrackerPrimaryEntityDetailsIfNeeded (trackerId, topicId) {
  return (dispatch, getState) => {
    const state = (getState().tracker.byId[trackerId] || {}).primaryEntity
    if (utils.shouldFetch(state)) {
      return dispatch(fetchTrackerPrimaryEntityDetails(trackerId, topicId))
    }
    return Promise.resolve()
  }
}

export function fetchTrackerTeasersAndTrailersIfNeeded (trackerId, trackerEntityId) {
  return (dispatch, getState) => {
    const state = (((getState().tracker.byId[trackerId] || {}).byTrackerEntityId || {})[trackerEntityId] || {}).teasersAndTrailers
    if (utils.shouldFetch(state)) {
      return dispatch(fetchTrackerTeasersAndTrailers(trackerId, trackerEntityId))
    }
    return Promise.resolve()
  }
}

export function fetchTrackerpageWhatsNewIfNeeded (trackerId, trackerEntityId, launchDate) {
  return (dispatch, getState) => {
    const state = (((getState().tracker.byId[trackerId] || {}).byTrackerEntityId || {})[trackerEntityId] || {}).whatsNew
    if (utils.shouldFetch(state)) {
      return dispatch(fetchTrackerWhatsNew(trackerId, trackerEntityId, launchDate))
    }
    return Promise.resolve()
  }
}

export function fetchTrackerpageWordCloudIfNeeded (trackerId, entityId) {
  return (dispatch, getState) => {
    const state = (((getState().tracker.byId[trackerId] || {}).byTrackerEntityId || {})[entityId] || {}).wordCloud
    if (utils.shouldFetch(state)) {
      return dispatch(fetchTrackerWordCloud (trackerId, entityId))
    }
    return Promise.resolve()
  }
}

export function fetchAverageBenchMarkTrackerPlanIfNeeded (trackerId) {
  return (dispatch, getState) => {
    const state = (getState().tracker.byId[trackerId] || {}).averagePlanDetails
    if (utils.shouldFetch(state)) {
      return dispatch(fetchAverageBenchMarkTrackerPlan(trackerId))
    }
    return Promise.resolve()
  }
}

export function fetchSingleTrackerEntityTimelineViewIfNeeded (trackerId, trackerEntityId) {
  return (dispatch, getState) => {
    const state = (((getState().tracker.byId[trackerId] || {}).byTrackerEntityId || {})[trackerEntityId] || {}).singleTrackerTimelineView
    if (utils.shouldFetch(state)) {
      return dispatch(fetchSingleTrackerEntityTimeLineView(trackerId, trackerEntityId))
    }
    return Promise.resolve()
  }
}

export function fetchSingleTrackerEntityPlanIfNeeded (trackerId, trackerEntityId) {
  return (dispatch, getState) => {
    const state = (((getState().tracker.byId[trackerId] || {}).byTrackerEntityId || {})[trackerEntityId] || {}).singleTrackerPlanDetails
    if (utils.shouldFetch(state)) {
      return dispatch(fetchSingleTrackerEntityPlan(trackerId, trackerEntityId))
    }
    return Promise.resolve()
  }
}

export function fetchAverageBenchMarkTrackerTimelineViewIfNeeded (trackerId) {
  return (dispatch, getState) => {
    const state = (getState().tracker.byId[trackerId] || {}).averageTimelineView
    if (utils.shouldFetch(state)) {
      return dispatch(fetchAverageBenchMarkTrackerTimelineView(trackerId))
    }
    return Promise.resolve()
  }
}

export function setSingleTrackerSelectedEntity (trackerId, trackerEntityId, trackerEntityType) {
  return {
    type: ActionTypes.SINGLE_TRACKER_SELECTED_ENTITY,
    trackerId,
    trackerEntityId,
    trackerEntityType
  }
}

export function setTrackerSelectedEntity (trackerId, trackerEntityId, trackerEntityType) {
  return {
    type: ActionTypes.TRACKER_SELECTED_ENTITY,
    trackerId,
    trackerEntityId,
    trackerEntityType
  }
}